import React from 'react';

const SEO = ({
  title,
  description,
  keywords,
  image,
  article = false,
  pathname,
  language = 'en',
  children,
}) => {
  const siteUrl = 'https://www.oomnis.io';
  const defaultImage = '/images/oomnis-og-image.jpg';

  // Construct proper URLs with language prefix
  // English (default) has no language prefix, other languages use /lang prefix
  const basePath = pathname || '/';
  const languagePrefix = language === 'en' ? '' : `/${language}`;
  const currentUrl = `${siteUrl}${languagePrefix}${basePath}`;

  const seo = {
    title: title || 'Oomnis',
    description: description || 'Oomnis - Innovative Solutions',
    image: `${siteUrl}${image || defaultImage}`,
    url: currentUrl,
    keywords: keywords || 'oomnis',
  };

  const pageTitle = title ? `${title} | Oomnis` : title || 'Oomnis';

  return (
    <>
      <html lang={language} />
      <title>{pageTitle}</title>

      {/* Primary Meta Tags */}
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={seo.keywords} />
      <meta name="image" content={seo.image} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={article ? 'article' : 'website'} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:site_name" content="Oomnis" />
      <meta property="og:locale" content={language === 'en' ? 'en_US' : language === 'fr' ? 'fr_FR' : language === 'ja' ? 'ja_JP' : language === 'es' ? 'es_ES' : 'en_US'} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />

      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />

      {/* Canonical URL - points to current language version */}
      <link rel="canonical" href={seo.url} />

      {/* Language alternates - hreflang tags for each language */}
      <link rel="alternate" hrefLang="en" href={`${siteUrl}${basePath}`} />
      <link rel="alternate" hrefLang="fr" href={`${siteUrl}/fr${basePath}`} />
      <link rel="alternate" hrefLang="ja" href={`${siteUrl}/ja${basePath}`} />
      <link rel="alternate" hrefLang="es" href={`${siteUrl}/es${basePath}`} />
      <link rel="alternate" hrefLang="x-default" href={`${siteUrl}${basePath}`} />

      {children}
    </>
  );
};

export default SEO;
